import { getMetricsV2 } from "@/entities/Finance/Finance.mutations";
import { useApiMutation } from "@/api/hooks/useApiMutation";
import { useMetricData } from "./useMetricData";
import { useMetricQuery } from "./useMetricQuery";
import { useMetricStack } from "./useMetricStack";
import { Spinner } from "@/ui/atoms/Spinner";
import { useState } from "react";
import clsx from "clsx";
import { VariableIcon } from "@heroicons/react/24/outline";

export function MetricHeader() {
    const { name, description, windowDescription, parsed, formula } =
        useMetricData();
    const { mutate: getMetrics, isPending } = useApiMutation(getMetricsV2, {
        onError: (error) => {
            console.log(error);
        },
    });
    const { appendToStack } = useMetricStack();
    const { currentMetricQuery } = useMetricQuery();
    const noChanges =
        currentMetricQuery?.metricQuery === currentMetricQuery?.metricQuery &&
        !!parsed;
    const [showFormula, setShowFormula] = useState(false);

    return (
        <>
            <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                    <h2>{name}</h2>
                    <p className="body-m subdued pt-1">
                        ({windowDescription || "All periods"})
                    </p>
                </div>
                <button
                    disabled={noChanges || isPending}
                    className="secondary xl"
                    onClick={() => {
                        if (noChanges) {
                            return;
                        }
                        appendToStack(currentMetricQuery);
                        getMetrics({
                            metricQuery: currentMetricQuery?.metricQuery,
                        });
                    }}
                >
                    {isPending && <Spinner className="size-4" />}
                    {isPending ? "Calculating..." : "Calculate metric"}
                </button>
            </div>
            {description && (
                <div className="flex items-center gap-3">
                    <p>{description}</p>
                    {formula && (
                        <p
                            className={clsx(
                                "body-micro subdued flex cursor-pointer items-center gap-1",
                            )}
                            onClick={() => setShowFormula(!showFormula)}
                        >
                            {showFormula ? "Hide formula" : "Show formula"}{" "}
                            <VariableIcon className="size-4" color="#E5E7EB" />
                        </p>
                    )}
                </div>
            )}
            {showFormula && (
                <div
                    className={clsx(
                        " bg-[#263142] p-5",
                        "flex flex-wrap",
                        "gap-2 rounded",
                    )}
                >
                    {formula?.map((line) => {
                        return (
                            <p className="py-1 font-[300]" key={line}>
                                {line +
                                    (line === formula[formula.length - 1]
                                        ? ""
                                        : " +")}
                            </p>
                        );
                    })}
                </div>
            )}
        </>
    );
}
